import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentThreadRenamed.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentThreadRenamedParams = {
  name: string;
};

export const useTrackAgentThreadRenamed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentThreadRenamed = useCallback(
    (params: UseTrackAgentThreadRenamedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentThreadRenamed };
};
